<template>
	<div class="index">


		<!-- 移动端、小屏幕菜单栏 -->
		<div class="mobile-nav-wrapper">
			<div class="mobile-menu-inner">
				<ul class="mobile-menu">
          <li ><a href="#" @click.prevent="toRouter('home');closeOl()">首页</a></li>
          <li ><a href="#" @click.prevent="toRouter('goodsType');closeOl()">产品</a></li>
          <li ><a href="#" @click.prevent="toRouter('comp_index');closeOl()">公司简介</a></li>
          <li ><a href="#" @click.prevent="toRouter('caseIndex');closeOl()">产品案例</a></li>
          <li ><a href="#" @click.prevent="toRouter('news');closeOl()">新闻</a></li>
          <li ><a href="#" @click.prevent="toRouter('join');closeOl()">加盟合作</a></li>
          <li ><a href="#" @click.prevent="toRouter('service');closeOl()">服务</a></li>
          <li ><a href="#" @click.prevent="toRouter('concatsus');closeOl()">联系我们</a></li>
        </ul>
				<ul class="social-icons">
        </ul>
			</div>
		</div>
		<div class="mobile-menu-overlay"></div>

		<!-- 顶部信息栏 -->


		<!-- 大页面菜单栏 -->
		<header class="site-header fixed-header" style="padding:0;box-shadow: 2px 2px 5px #ccc;height: 60px">
			<div class="container expanded">
				<div class="header-wrap">
					<div class="header-logo">
						<a href="index.html">
							<!-- <h2>梵蒂斯<em>.</em></h2> -->
							<img src="static/logo_white.png" style="width: 70%" />
						</a>
					</div>
					<div class="header-nav">
						<ul class="main-menu">
							<li ><a href="#" @click.prevent="toRouter('home')">首页</a></li>
							<li ><a href="#" @click.prevent="toRouter('goodsType')">产品</a></li>
							<li ><a href="#" @click.prevent="toRouter('comp_index')">公司简介</a></li>
							<li ><a href="#" @click.prevent="toRouter('caseIndex')">产品案例</a></li>
							<li ><a href="#" @click.prevent="toRouter('news')">新闻</a></li>
							<li ><a href="#" @click.prevent="toRouter('join')">加盟合作</a></li>
							<li ><a href="#" @click.prevent="toRouter('service')">服务</a></li>
							<li ><a href="#" @click.prevent="toRouter('concatsus')">联系我们</a></li>
						</ul>
					</div>

					<div class="header-widgets">
						<ul class="right-menu">

							<li class="menu-item menu-mobile-nav">
								<a href="#" class="menu-bar" id="menu-show-mobile-nav">
									<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
										stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
										class="css-i6dzq1">
										<line x1="3" y1="12" x2="21" y2="12"></line>
										<line x1="3" y1="6" x2="21" y2="6"></line>
										<line x1="3" y1="18" x2="21" y2="18"></line>
									</svg>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</header>
		<!-- /头部结束 -->

    <!-- 路由切换内容 -->
    <div class="main">
      <router-view />
    </div>

    <!-- 公共页脚 -->
    <Foot />

		<a href="#" class="go-top"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
				stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
				<line x1="12" y1="19" x2="12" y2="5"></line>
				<polyline points="5 12 12 5 19 12"></polyline>
			</svg></a>

	</div>
</template>

<script>
	import Foot from '@/components/common_foot.vue'

	export default {
		name: 'HelloWorld',
    components:{Foot},
		data() {
			return {
        common_platform_data:{
          "id": null,
          "createBy": null,
          "createTime": null,
          "updateBy": null,
          "updateTime": null,
          "sysOrgCode": null,
          "platformName": null,
          "platformAdvertisement": null,
          "compName": null,
          "compEmail": null,
          "compTell": null,
          "compAddress": null,
          "compAddressLat": null,
          "compAddressLong": null,
          "compJoinTell": null,
          "compSQq": null,
          "compSWchat": null,
          "compWgzhRcode": null,
          "compSWchatRcode": null,
          "icpName": null,
          "icpHost": null,
          "icpYear": null,
          "icpCode": null
        }
			}
		},
    created() {
      this.getCompInfoData();
    },
    methods:{
      //自动关闭遮罩
      closeOl(){
        document.getElementsByClassName("mobile-menu-overlay")[0].click();
      },
      // 查询公司以及平台信息
      getCompInfoData(){
        let _this = this;
        this.$axios.get('/fantis/compdata/ftComp/queryById?id=101')
          .then(function(res){ // 请求成功 HTTP状态码是200
            if(res.data.code == 200){
              var tempData = res.data.result;
              _this.common_platform_data = res.data.result;
              if(_this.common_platform_data.compWgzhRcode!=null && _this.common_platform_data.compWgzhRcode!=""){
                _this.common_platform_data.compWgzhRcode =
                  _this.$fileDPath + _this.common_platform_data.compWgzhRcode;
              }
              if(_this.common_platform_data.compSWchatRcode!=null && _this.common_platform_data.compSWchatRcode!=""){
                _this.common_platform_data.compSWchatRcode =
                  _this.$fileDPath + _this.common_platform_data.compSWchatRcode;
              }
            }else{
              _this.$message.error(res.data.msg);
            }
          })
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      },
      // 点击跳转路由
      toRouter(routerName){
        this.$router.push({name:routerName});
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // 可选，平滑滚动效果
        });
      }
    }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 100%;
  height: auto;
  margin-top: 60px;
}
.site-header.fixed-header {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  background-color: #fff;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.menu-bar {
  height: 60px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue